import { UseMutationOptions } from '@tanstack/react-query';
import { useMutation, useQuery } from 'data/utils/useQuery';
import { CommandControllerService, CommandDto, LogControllerService } from 'data/openapi';
import { QueryKeys } from 'data/constants';
import { useDataConfig } from 'data/utils/hooks';

export const useExecuteCommand = (name: string, options?: UseMutationOptions<void, any, CommandDto, any>) => {
  return useMutation(async (values: CommandDto) => {
    await CommandControllerService.executeCommand(name, values);
  }, options);
};

export const useCommandHistory = (name: string) => {
  const { pollingInterval } = useDataConfig();
  return useQuery([QueryKeys.COMMANDS, name], () => LogControllerService.printConsoleOutput(name), {
    refetchInterval: pollingInterval,
  });
};
